module.exports = __webpack_public_path__ + "img/style1.9941fd5a.png";